import { Avatar, Heading } from '@lmc/ui-kit'
import { styled } from 'styled-components'
import { User } from '@lmc/ts-common'
import InfoIcons from 'screens/Rostering/RotaBuilder/common/components/InfoIcons'
import { useTranslation } from 'react-i18next'

type TeamMemberInfoProps = {
  teamMember: User
  avatarSize?: number
}

const TeamMemberInfo = ({ teamMember, avatarSize }: TeamMemberInfoProps) => {
  const { t } = useTranslation()

  if (!teamMember)
    return (
      <SectionWrapper>
        <StyledAvatar size={avatarSize || 22} />
        <Heading level={5} weight="medium">
          {t('DELETED_USER')}
        </Heading>
      </SectionWrapper>
    )

  return (
    <SectionWrapper>
      <StyledAvatar
        size={avatarSize || 22}
        url={teamMember.picture as unknown as string}
      />
      <Heading level={5} weight="medium">
        {`${teamMember.name?.first} ${teamMember.name?.last}`}
      </Heading>
      <InfoIcons
        email={teamMember.email}
        phone={teamMember.phoneNumber}
        notes={teamMember.workProfile?.rotaPreferenceNotes}
        inactive={!teamMember.active}
        deleted={teamMember.deleted}
      />
    </SectionWrapper>
  )
}

const StyledAvatar = styled(Avatar)`
  border: 0.5px solid ${(props) => props.theme.color.neutral.color7};
`

const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export default TeamMemberInfo
